import {createProject, getProjects} from '@/models/project'
const initialState = {}; // can load from localStorage

export default {
  ...initialState,
  dialog: {
    open: false,
    operation: 'ADD',
    text: 'Save'
  },
  project: createProject(),
  projects: [],
  loading: false
}
